import { Button } from 'antd';
import type { ButtonProps } from 'antd';

export interface DButtonProps extends ButtonProps {}

export const DarwinButton = (props: DButtonProps) => {
  return <Button {...props} />;
};
